import { Phone, ClipboardList } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function MobileBar() {
  const nav = useNavigate();
  return (
    <div data-testid="mobile-bar" className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-ivory/95 backdrop-blur-md border-t border-black/10 flex shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <button
        data-testid="mobile-bar-estimer"
        onClick={() => nav("/estimation")}
        className="flex-1 flex items-center justify-center gap-2 py-4 text-stone-900 font-semibold text-sm"
      >
        <ClipboardList size={18} /> Estimer
      </button>
      <a
        data-testid="mobile-bar-appeler"
        href="tel:0627443230"
        className="flex-1 flex items-center justify-center gap-2 py-4 bg-bordeaux text-stone-50 font-semibold text-sm"
      >
        <Phone size={18} /> Appeler
      </a>
    </div>
  );
}
